export default __webpack_public_path__ + "static/media/space-background.94453a69.svg";